import { useMemo } from 'react';
import { COUNTRIES } from '@hotjar/country-lib';

export interface CountryChoice {
  label: string;
  value: string;
}

export const useCountryChoices = (): CountryChoice[] => {
  return useMemo(() => {
    const allowedCountries: CountryChoice[] = [];
    const sanctionedCountries = window.settings?.sanctioned_countries || [];

    return COUNTRIES.reduce((countries, country) => {
      if (
        !sanctionedCountries.find((sanctionedCountry) => sanctionedCountry.code === country.value)
      ) {
        countries.push({ ...country });
      }
      return countries;
    }, allowedCountries);
  }, []);
};
